import { ReactNode } from "react";
import dynamic from "next/dynamic";
import { useTheme } from "styled-components";
import {
  DesktopAdAliases,
  MobileAdAliases,
} from "../../../../componentReusable/Ads/AdsBillBoard/adsConfigs";

const Suspense = ({ children, fallback: string }) => children;

const CustomizedPageLayoutDesktop = dynamic(
  () =>
    import(
      "components/Layouts/PageLayouts/CustomizedPageLayout/CustomizedPageLayoutDesktop"
    ),
  { suspense: false }
);
const CustomizedPageLayoutMobile = dynamic(
  () =>
    import(
      "components/Layouts/PageLayouts/CustomizedPageLayout/CustomizedPageLayoutMobile"
    ),
  { suspense: false }
);

export interface ILayoutProps {
  children: ReactNode;
  supportSplash?: boolean;
  supportBottomSticky?: boolean;
  supportBottomNavigation?: boolean;
  //Headers
  enableH1?: boolean;
  enableH2?: boolean;
  enableH3?: boolean;
  enableH4?: boolean;
  enableH5?: boolean;
  //Footers
  enableF1?: boolean;
  enableF2?: boolean;
  enableF3?: boolean;
  enableF4?: boolean;
  adName?: MobileAdAliases | DesktopAdAliases;
  layoutProps?: any;
  enableSmartBanner?: boolean;
  linkedAds?: string;
}

function CustomizedPageLayout(props: ILayoutProps) {
  const { isDesktop } = useTheme();
  if (isDesktop) {
    return (
      <Suspense fallback={"Loading ..."}>
        <CustomizedPageLayoutDesktop {...props} />
      </Suspense>
    );
  } else {
    return (
      <Suspense fallback={"Loading ..."}>
        <CustomizedPageLayoutMobile {...props} />
      </Suspense>
    );
  }
}

export default CustomizedPageLayout;
